import { useTranslation } from 'react-i18next';
import { SelectOption } from '@anytag/shared-types';
import { Form, SocialIcon } from '@anytag/shared-atoms';
import { SelectorField } from '@anytag/shared-molecules';
import { useAllCountryOptions, useFollowerGrowthOptions, useAllInfluencerCategoryOptions } from '@anytag/shared-hooks';
import { TrendingInfluencersTabType, TrendingInfluencersFilterFormKeys } from './schemaTypes';
import { ExportButton } from './export-button';

interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const { allCountryOptions } = useAllCountryOptions();
  const { followerGrowthPeriodOptions } = useFollowerGrowthOptions();
  const { allInfluencerCategoryOptions } = useAllInfluencerCategoryOptions();

  const followerOptions: SelectOption<string>[] = [
    { label: '0~', value: '0' },
    { label: '10,000~', value: '10000' },
    { label: '100,000~', value: '100000' },
    { label: '500,000~', value: '500000' }
  ];
  const socialMediaOptions: SelectOption<TrendingInfluencersTabType>[] = [
    {
      label: t<string>('Instagram'),
      prefixIcon: <SocialIcon type="INSTAGRAM" />,
      value: TrendingInfluencersTabType.INSTAGRAM
    },
    {
      label: t<string>('Youtube'),
      prefixIcon: <SocialIcon type="YOUTUBE" />,
      value: TrendingInfluencersTabType.YOUTUBE
    },
    {
      label: t<string>('Facebook'),
      prefixIcon: <SocialIcon type="FACEBOOK" />,
      value: TrendingInfluencersTabType.FACEBOOK
    }
  ];

  return (
    <Form.Fields>
      <SelectorField<TrendingInfluencersFilterFormKeys>
        name="tab"
        clearable={false}
        onSubmit={onSubmit}
        options={socialMediaOptions}
        title={t('Selector.Social Media')}
        placeholder={t<string>('Selector.Social Media')}
        showAllOptions
      />

      <SelectorField<TrendingInfluencersFilterFormKeys>
        name="countryId"
        clearable={false}
        onSubmit={onSubmit}
        options={allCountryOptions}
        title={t('Selector.Country')}
        placeholder={t<string>('Selector.Country')}
      />

      <SelectorField<TrendingInfluencersFilterFormKeys>
        name="categoryIds"
        onSubmit={onSubmit}
        title={t('Selector.Topics')}
        options={allInfluencerCategoryOptions}
        placeholder={t<string>('Selector.topicsPlaceholder')}
        multiple
      />

      <SelectorField<TrendingInfluencersFilterFormKeys>
        clearable={false}
        onSubmit={onSubmit}
        name="followerGrowthPeriod"
        title={t('Selector.Growth period')}
        options={followerGrowthPeriodOptions}
        placeholder={t<string>('Selector.Follower Growth Period')}
      />

      <SelectorField<TrendingInfluencersFilterFormKeys>
        clearable={false}
        onSubmit={onSubmit}
        name="minFollowers"
        options={followerOptions}
        title={t('Selector.Followers')}
        placeholder={t<string>('Selector.Number of Followers')}
      />
      <ExportButton />
    </Form.Fields>
  );
};
